export default __webpack_public_path__ + "static/media/kinepolis-480.7d096caa.jpg";